<div class="white-section py-3 px-lg-5 px-md-4 px-3">
  <h1 class="section-header">You are logged out</h1>
  <p class="py-4">
    Thank you for using Nicola Wealth Secured Client Access.
    You are now logged out.<br/>
  </p>
  <a class="btn-primary w-100 my-3" routerLink="/account/login">Login Again</a>
</div>